/**
 * @generated SignedSource<<85f9f7d308d6a589a5fe8d2c06a74ea0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SuperSearchConfig_user$data = {
  readonly account: {
    readonly id: number;
    readonly " $fragmentSpreads": FragmentRefs<"PersonCustomFieldTypes_accounts" | "ProjectCustomFieldTypes_accounts">;
  };
  readonly email: string;
  readonly first_name: string | null | undefined;
  readonly id: number;
  readonly image_key: string | null | undefined;
  readonly last_name: string | null | undefined;
  readonly people: ReadonlyArray<{
    readonly active: boolean;
    readonly email: string | null | undefined;
    readonly first_name: string;
    readonly id: number;
    readonly image_key: string | null | undefined;
    readonly last_name: string;
  }>;
  readonly permissions: any;
  readonly " $fragmentType": "SuperSearchConfig_user";
};
export type SuperSearchConfig_user$key = {
  readonly " $data"?: SuperSearchConfig_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SuperSearchConfig_user">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "first_name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "last_name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image_key",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SuperSearchConfig_user",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    (v3/*: any*/),
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "permissions",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "limit",
          "value": 1
        }
      ],
      "concreteType": "people",
      "kind": "LinkedField",
      "name": "people",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/),
        (v4/*: any*/),
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "active",
          "storageKey": null
        }
      ],
      "storageKey": "people(limit:1)"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "accounts",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProjectCustomFieldTypes_accounts"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PersonCustomFieldTypes_accounts"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "users",
  "abstractKey": null
};
})();

(node as any).hash = "59f6910f88e62f9f84e9c1cf22904083";

export default node;
